<template>
  <el-row>
    <el-col :span="24" class="group-search">
      <el-form label-width="140px" :model="params" label-position="left" ref="form">
        <p class="title-search">Danh sách tải lên thành công từ tệp danh sách</p>
        <el-row>
          <el-col :span="11" class="degree-search_code">
            <el-form-item label="Mã học viên">
              <el-input v-model="params.code_student" @keyup.enter.native="searchDegree"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2" class="degree-search_name">
            <el-form-item label="Họ và tên">
              <el-input v-model="params.name" @keyup.enter.native="searchDegree"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" class="degree-search_td">
            <el-form-item label="Trình độ">
              <el-select
                style="width: 100%;"
                v-model="params.certificate"
                clearable
                placeholder="Tất cả"
              >
                <el-option
                  :label="certificate.name"
                  :value="certificate.name"
                  v-for="certificate in getMasterData.certificaties"
                  :key="certificate.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2" class="degree-search_td">
            <el-form-item label="Ngày tải lên" prop="end_date">
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="Ngày/tháng/năm"
                  format="dd/MM/yyyy"
                  style="width: 100%;"
                  v-model="params.start_date"
                  value-format="yyyy/MM/dd"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">~</el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="Ngày/tháng/năm"
                  format="dd/MM/yyyy"
                  style="width: 100%;"
                  v-model="params.end_date"
                  value-format="yyyy/MM/dd"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="16" class="button-search">
            <el-form-item>
              <el-button type="primary" class="btn-search" @click="searchDegree">Tìm</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
    <el-col :span="24" class="list-button">
      <div class="pagination-size">
        <p>Số bản ghi trên trang:</p>
        <el-dropdown @command="ChangePageSize">
          <span class="el-dropdown-link">
            {{ params.limit }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in listPaginate"
              :key="item.key"
              :command="item.value"
            >{{ item.value }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="check-all">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAll()"
        >Đã chọn ({{ numberChecked }}/{{ total }} văn bằng)</el-checkbox>
      </div>
      <el-button
        type="danger"
        class="btn-delete"
        :disabled="loading || (multipleSelection.length === 0 && !checkAll) || getData.length === 0"
        @click="handleConfirmDelete()"
      >Xóa</el-button>
      <el-button
        type="success"
        class="btn-add"
        @click="handleConfirmSend()"
      >Gửi Bộ GDĐT</el-button>
      <el-dropdown @command="handleExportCommand">
        <el-button type="warning" class="btn-export">
          Kết Xuất<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="excel">Kết xuất (Excel)</el-dropdown-item>
          <el-dropdown-item command="pdf">Kết xuất (PDF)</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>

    <el-card>
      <el-col :span="24" class="degree-table">
        <template>
          <el-table
            ref="table"
            :data="getData"
            @select="handleSelect"
            style="width: 100%"
            empty-text="Không có dữ liệu"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="Số vào sổ cấp bằng" :min-width="90">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  @click="$router.push({name: 'DraftDegreeDetail',
                  query: {id: scope.row.id}})"
                >{{ scope.row.log_number }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="code_student" label="Mã học viên"></el-table-column>
            <el-table-column prop="name" label="Họ và tên"></el-table-column>
            <el-table-column prop="graduation_year" label="Năm tốt nghiệp"></el-table-column>
            <el-table-column label="Xếp loại tốt nghiệp">
              <template scope="scope">{{ scope.row.ranking ? scope.row.ranking.type : '' }}</template>
            </el-table-column>
            <el-table-column prop="certificate" label="Trình độ"></el-table-column>
            <el-table-column prop="request_type" label="Loại yêu cầu"></el-table-column>
            <el-table-column prop="updated_at" label="Thời gian tải lên">
              <template scope="scope">{{ scope.row.created_at | formatHour }}</template>
            </el-table-column>
            <el-table-column prop="updated_at" label="Ngày tải lên">
              <template scope="scope">
                {{ scope.row.created_at | formatDate}}
                <el-tooltip
                  v-if="scope.row.status === status_error"
                  :content="'Yêu cầu gửi lên Bộ GDĐT thất bại tại thời điểm ' +
                  $options.filters.formatDatetimeES(scope.row.updated_at )"
                  placement="top-end"
                  effect="light"
                >
                  <i class="warning-change-pass"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <custom-el-pagination
            :length="getData.length"
            :paginateFrom="paginateFrom"
            :paginateTo="paginateTo"
            :total="total"
            :pageSize="pageSize"
            :page="page"
            @handleCurrentChange="handleCurrentChange"
          ></custom-el-pagination>
        </template>
      </el-col>
    </el-card>
    <el-dialog class="custom_dialog" title="Xác Nhận" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules"  ref="form" >
        Bạn có chắc chắn muốn gửi {{numberChecked}} văn bằng không?
        <el-form-item label="Vui lòng nhập mật khẩu:" prop="password">
          <el-input type="password" v-model="form.password" name="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="el-button el-button--default el-button--small" @click="dialogFormVisible = false">Hủy</el-button>
        <el-button class="el-button el-button--default el-button--small" type="primary" @click="handleComfirmPassword()">Xác Nhận</el-button>
      </span>
    </el-dialog>

    <!-- Dialog cho upload PDF -->
    <el-dialog
      title="Upload danh sách văn bằng đã ký số"
      :visible.sync="uploadDialogVisible"
      width="500px"
      class="upload-dialog"
      :close-on-click-modal="false"
    >
      <div class="upload-container">
        <el-upload
          v-if="!selectedFile"
          class="upload-area"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleUploadChange"
          :file-list="fileList"
          :limit="1"
          :multiple="false"
          accept=".pdf"
          :show-file-list="false"
        >
          <div>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Kéo thả file vào đây hoặc <em>click để chọn file</em>
            </div>
            <div class="el-upload__tip" slot="tip">Chỉ chấp nhận file PDF</div>
          </div>
        </el-upload>
        
        <div v-if="selectedFile" class="selected-file">
          <div class="file-preview">
            <i class="el-icon-document"></i>
            <div class="file-info">
              <span class="file-name">{{ selectedFile.name }}</span>
            </div>
            <i class="el-icon-close remove-file" @click="removeFile"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload">Hủy</el-button>
        <el-button type="warning" @click="handleViewSignature" :disabled="!selectedFile">
          Kiểm tra chữ ký số
        </el-button>
        <el-button type="primary" @click="handleUploadPDF" :disabled="!selectedFile">
          Upload
        </el-button>
      </span>
    </el-dialog>

    <signature-verification-dialog
      ref="signatureDialog"
      :visible.sync="showSignatureDialog"
      :file="selectedFile"
    />
  </el-row>
</template>

<script>
import DegreeCooperatorRequest from "@/requests/DegreeCooperatorRequest";
import CONST from "@/config/const";
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import SignatureVerificationDialog from '@/components/SignatureVerificationDialog.vue';
import { PDFDocument } from 'pdf-lib';

export default {
  name: "DegreeSuccess",
  components: {
    SignatureVerificationDialog,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      getData: [],
      params: {
        limit: CONST.PAGINATION[0].value,
      },
      paramsAfterSearch: {},
      multipleSelection: [],
      page: 1,
      pageSize: CONST.PAGINATION[0].value,
      total: 0,
      paginateFrom: 1,
      paginateTo: CONST.PAGINATION[0].value,
      listPaginate: CONST.PAGINATION,
      lastPage: 2,
      checkAll: false,
      isIndeterminate: false,
      loading: false,
      numberChecked: 0,
      status_error: "error",
      responseTime: "",
      paramsSearch: {},
      dialogFormVisible: false,
      uploadDialogVisible: false,
      selectedFile: null,
      fileList: [],
      form : {
        password: ""
      },
      rules: {
        password: [
          {
            required: true,
            message: "Vui lòng nhập mật khẩu.",
            trigger: "blur",
          },
        ]
      },
      signatureInfo: null,
      showSignatureDialog: false,
      loadingSignature: false,
      metadata: {
        title: 'Không có tiêu đề',
        author: 'Không xác định',
        creator: 'Không xác định',
        creationDate: 'Không xác định',
        modificationDate: 'Không xác định'
      },
      totalPages: 0,
    };
  },
  computed: {
    ...mapGetters(["getMasterData"]),
  },
  methods: {
    async getList(params) {
      this.paramsSearch = { ...params };
      const data = await DegreeCooperatorRequest.getDegree(params);
      this.getData = data.data;
      this.page = data.current_page;
      this.pageSize = parseInt(data.per_page);
      this.total = data.total;
      this.paginateFrom = data.from;
      this.paginateTo = data.to;
      this.lastPage = parseInt(data.last_page);
      this.paramsAfterSearch = _.clone(this.params);
    },
    searchDegree() {
      this.params.page = 1;
      this.paramsSearch = {...this.params};
      this.getList(this.params);
      this.multipleSelection = [];
      this.checkAll = false;
    },
    async handleComfirmPassword(){
      let valid = await this.$refs['form'].validate();
      if (!valid) {
        return;
      }
      const params = {
        password: this.form.password,
        response_time: this.responseTime,
        check_all: this.checkAll,
        list_drafts: this.multipleSelection,
        ...this.paramsAfterSearch,
      };
      this.loading = true;
      const fullLoading = this.$loading({
        lock: true,
        text: 'Đang trong quá trình xử lý gửi lên Bộ GDĐT, vui lòng chờ ít phút.',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      DegreeCooperatorRequest.sendDegree(params, this.numberChecked)
        .then((res) => {
          let totalSuccess = res.data.success;
          let totalErr = res.data.error;
          let message = `Gửi lên Bộ GD&ĐT thành công. Có ${totalSuccess} yêu cầu gửi thành công và ${totalErr} yêu cầu gửi thất bại.`;
          this.showSuccess(message);
          this.getList(this.params);
          this.multipleSelection = [];
          this.numberChecked = 0;
          this.checkAll = false;
          this.dialogFormVisible = false
          this.loading = false;
        })
        .catch((err) => {
          this.showError(err.response.data.message);
          this.loading = false;
        })
        .finally(() => {
          fullLoading.close();
        });
    },
    async handleConfirmSend() {
      this.uploadDialogVisible = true;
    },
    async handleConfirmDelete() {
      if (this.multipleSelection.length || this.checkAll) {
        if (await this.showConfirmMixin('Bạn có chắc chắn muốn xóa ' + this.numberChecked + ' văn bằng không?')) {
          const params = {
            response_time: this.responseTime,
            check_all: this.checkAll ? 1 : 0,
            list_drafts: this.multipleSelection,
            ...this.paramsAfterSearch,
          };
          this.loading = true;
          DegreeCooperatorRequest.deleteDegree(params, this.numberChecked)
            .then(() => {
              this.showSuccess("Xóa thành công.");
              this.getList(this.params);
              this.multipleSelection = [];
              this.numberChecked = 0;
              this.checkAll = false;
              this.loading = false;
            })
            .catch((err) => {
              this.showError(err.response.data.message);
              this.loading = false;
            })
            .finally(() => {
              if (this.checkAll) this.checkAll = false;
            });
        }
      }
    },
    exportDegree() {
      DegreeCooperatorRequest.exportDegree(this.paramsSearch).then((res) => {
        this.downloadFile(res, "Van_bang_thanh_cong");
      });
    },
    handleExportCommand(command) {
      if (command === 'excel') {
        this.exportDegree();
      } else if (command === 'pdf') {
        if (this.multipleSelection.length === 0 && !this.checkAll) {
          this.showError("Vui lòng chọn ít nhất một văn bằng để kết xuất");
          return;
        }
        const params = {
          degree_ids: this.multipleSelection,
          check_all: this.checkAll ? true : false,
          ...this.paramsAfterSearch,
        };
        DegreeCooperatorRequest.exportSelectedDegreePDF(params)
          .then((res) => {
            this.downloadFile(res, `Tai-len-van-bang-ngay-${moment().format('DD-MM-YYYY')}`, 'pdf');
          })
          .catch((err) => {
            this.showError(err.response?.data?.message || "Có lỗi xảy ra khi kết xuất PDF");
          });
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      const param = Object.assign(this.paramsSearch, {
        page: this.page,
      });
      this.getList(param);
    },
    setStartDate() {
      this.params.start_date = moment(String(this.params.start_date)).format(
        "YYYY/MM/DD"
      );
    },
    setEndDate() {
      this.params.end_date = moment(String(this.params.end_date)).format("YYYY/MM/DD");
    },
    totalChecked() {
      if (this.checkAll) {
        // Chỉ tính số lượng bản ghi trên trang hiện tại
        this.numberChecked = this.getData.length;
      } else {
        this.numberChecked = this.multipleSelection.length;
      }
    },
    handleCheckAll(val) {
      if (this.checkAll) {
        // Khi tick vào "Chọn tất cả", thêm các dòng chưa được chọn vào multipleSelection
        this.getData.forEach(row => {
          if (!this.multipleSelection.includes(row.id)) {
            this.multipleSelection.push(row.id);
          }
          // Đánh dấu tick cho tất cả các dòng
          this.$refs.table.toggleRowSelection(row, true);
        });
      } else {
        // Khi bỏ tick "Chọn tất cả", xóa tất cả các lựa chọn
        this.multipleSelection = [];
        this.$refs.table.clearSelection();
      }
      this.totalChecked();
      this.responseTime = moment().utc().format();
    },
    handleSelect(selection, row) {
      if (this.multipleSelection.includes(row.id)) {
        this.multipleSelection.splice(
          this.multipleSelection.indexOf(row.id),
          1
        );
      } else {
        this.multipleSelection.push(row.id);
      }
      this.totalChecked();
    },
    ChangePageSize(e) {
      this.params.limit = e;
      this.params.page = 1;
      this.getList(this.params);
    },
    handleUploadChange(file) {
      if (file.raw.type !== 'application/pdf') {
        this.$message.error('Chỉ chấp nhận file PDF!');
        return;
      }
      this.selectedFile = file.raw;
      this.fileList = [file];
    },
    removeFile() {
      this.selectedFile = null;
      this.fileList = [];
    },
    cancelUpload() {
      this.uploadDialogVisible = false;
      this.removeFile();
    },
    handleViewSignature() {
      this.checkBasicSignatureStructure().then(hasSignatureMarkers => {
        if (!hasSignatureMarkers) {
          this.$confirm(
            'Không tìm thấy dấu hiệu của chữ ký số trong file. File PDF này có thể chưa được ký số hoặc sử dụng định dạng chữ ký không được hỗ trợ. Bạn vẫn muốn xem thông tin chi tiết?', 
            'Cảnh báo', 
            {
              confirmButtonText: 'Xem chi tiết',
              cancelButtonText: 'Hủy',
              type: 'warning'
            }
          )
          .then(() => {
            this.$nextTick(() => {
              this.$refs.signatureDialog.setNoSignatureMode();
              this.showSignatureDialog = true;
            });
          })
          .catch(() => {});
        } else {
          this.showSignatureDialog = true;
        }
      });
    },
    async checkBasicSignatureStructure() {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const arrayBuffer = e.target.result;
            const bytes = new Uint8Array(arrayBuffer);
            const maxLength = bytes.length; // Chỉ kiểm tra 5KB đầu tiên
            let text = '';
            
            for (let i = 0; i < maxLength; i++) {
              text += String.fromCharCode(bytes[i]);
            }

            // Kiểm tra các pattern chữ ký phổ biến
            const hasSignatureMarkers = 
              text.includes('/Type/Sig') || 
              text.includes('/FT/Sig') || 
              text.includes('/adbe.pkcs7') || 
              text.includes('/ByteRange') ||
              text.includes('/ETSI.') ||
              text.includes('/SubFilter');
            
            resolve(hasSignatureMarkers);
          } catch (error) {
            console.error('Error checking signature structure:', error);
            resolve(false);
          }
        };
        reader.onerror = () => resolve(false);
        reader.readAsArrayBuffer(this.selectedFile);
      });
    },
    async handleUploadPDF() {
      if (!this.selectedFile) return;

      const formData = new FormData();
      formData.append('pdf_file', this.selectedFile);

      try {
        await DegreeCooperatorRequest.uploadDegreePDF(formData);
        this.$message.success('Upload thành công');
        this.uploadDialogVisible = false;
        this.removeFile();
        this.getList(this.params);
      } catch (error) {
        console.log(error);
        this.$message.error(error.response?.data?.message || 'Có lỗi xảy ra khi upload file');
      }
    },
    setNoSignatureMode() {
      this.noSignatureMode = true;
      this.loading = false;
      this.error = null;
      this.signatureInfo = [];
      this.totalPages = 0;

      // Hiển thị tên file trước
      this.metadata = {
        title: this.file ? this.file.name : 'Không có tiêu đề',
        author: 'Không xác định',
        creator: 'Không xác định',
        creationDate: 'Không xác định',
        modificationDate: 'Không xác định'
      };

      if (this.file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const arrayBuffer = e.target.result;
            const pdfDoc = await PDFDocument.load(arrayBuffer);

            // Lấy số trang
            this.totalPages = pdfDoc.getPageCount();

            // Lấy metadata từ info dictionary
            const infoDict = pdfDoc.context.lookup(pdfDoc.context.trailerInfo.Info);

            console.log("infoDict");
            console.log(infoDict);
            if (infoDict) {
              this.metadata = {
                title: infoDict.get('Title') ? infoDict.get('Title').decodeText() : this.file.name,
                author: infoDict.get('Author') ? infoDict.get('Author').decodeText() : 'Không xác định',
                creator: infoDict.get('Creator') ? infoDict.get('Creator').decodeText() : 'Không xác định',
                creationDate: infoDict.get('CreationDate') ? this.formatDate(infoDict.get('CreationDate').decodeText()) : 'Không xác định',
                modificationDate: infoDict.get('ModDate') ? this.formatDate(infoDict.get('ModDate').decodeText()) : 'Không xác định'
              };
            } else {
              // Nếu không có info dictionary, giữ nguyên metadata mặc định
              this.metadata = {
                title: this.file.name,
                author: 'Không xác định',
                creator: 'Không xác định',
                creationDate: 'Không xác định',
                modificationDate: 'Không xác định'
              };
            }
          } catch (error) {
            console.error('Error reading PDF metadata:', error);
          }
        };
        reader.readAsArrayBuffer(this.file);
      }
    },
    formatDate(pdfDateString) {
      // Chuỗi ngày PDF thường có dạng D:YYYYMMDDHHmmSS
      if (!pdfDateString) return 'Không xác định';
      const match = pdfDateString.match(/D:(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})?/);
      if (match) {
        const [, year, month, day, hour, min, sec] = match;
        return `${day}/${month}/${year} ${hour || '00'}:${min || '00'}:${sec || '00'}`;
      }
      return pdfDateString;
    },
  },
  watch: {
    multipleSelection: function (newval, oldVal) {
      if (this.checkAll) {
        this.isIndeterminate = newval.length > 0 && newval.length < this.total;
      } else {
        this.isIndeterminate = false;
      }
      this.totalChecked();
    },
    dialogFormVisible:function (){
      this.$refs['form'].resetFields()
    }
  },
  created() {
    this.getList(this.params);
  },
  updated() {
    if (this.checkAll) {
      // Đảm bảo tất cả các dòng đều được chọn khi ở trạng thái "Chọn tất cả"
      this.getData.forEach(row => {
        if (!this.multipleSelection.includes(row.id)) {
          this.multipleSelection.push(row.id);
        }
        this.$refs.table.toggleRowSelection(row, true);
      });
    } else {
      // Chỉ chọn những dòng có trong multipleSelection
      this.getData.forEach(row => {
        this.$refs.table.toggleRowSelection(row, this.multipleSelection.includes(row.id));
      });
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/_variables";
.degree-search {
  .el-form-item {
    label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: $color_mine_shaft;
    }
  }
}
.check-all {
  pointer-events: none;
  .el-checkbox__input {
    position: absolute;
    top: 77px;
    left: 35px;
    pointer-events: auto;
  }
  .el-checkbox__label {
    padding-left: 0px;
  }
  .el-checkbox.is-checked {
    .el-checkbox__label {
      color: $color_mine_shaft;
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/sass/_variables";
.line {
  text-align: center;
}
.list-button {
  position: relative;
  .pagination-size {
    top: -30px;
  }
  .check-all {
    position: absolute;
    left: 0px;
    top: 20px;
    .el-checkbox {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: $color_mine_shaft;
    }
  }
  .el-dropdown {
    margin-left: 10px;
  }
  .btn-export {
    min-width: 100px;
  }
}
.warning-change-pass {
  padding-right: 10px;
  &:before {
    content: url("../../../assets/images/icons/warning-change-pass.svg");
  }
}
.custom_dialog {
  text-align: center;
  display: flex;
  align-items: center;
  /deep/.el-dialog{
    margin-top: unset;
    display: inline-block;
    width: 420px;
    padding-bottom: 10px;
    vertical-align: middle;
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    text-align: left;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  /deep/.el-dialog__header {
    position: relative;
    padding: 15px 15px 10px;

    .el-dialog__title {
      font-weight: bold;
    }
  }
  /deep/.el-dialog__body {
    padding: 0px 15px 10px;
    .el-form{
      border: 0;
      .el-form-item__label, .el-form-item__content{
        width: 100% !important;
        text-align: left !important;
        margin-left: 0 !important;
      }
    }
  }
  /deep/.el-dialog__footer {
    padding: 0px 15px 0;
  }
}
.upload-dialog {
  .upload-container {
    padding: 20px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .upload-area {    
    .el-upload {
      width: 100%;
      display: flex;
      justify-content: center;

      .el-upload-dragger {
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        
        .el-icon-upload {
          font-size: 40px;
          color: #909399;
          margin-bottom: 10px;
        }
        
        .el-upload__text {
          color: #606266;
          font-size: 14px;
          text-align: center;
          margin: 7px 0;
          
          em {
            color: #409EFF;
            font-style: normal;
            cursor: pointer;
          }
        }
      }
    }
    .el-upload__tip {
      text-align: center;
      color: #909399;
      font-size: 12px;
      margin-top: 7px;
    }
  }
  
  .selected-file {
    width: 90%;
    padding: 10px 0;
    
    .file-preview {
      display: flex;
      align-items: center;
      padding: 10px;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      background-color: #F5F7FA;
      position: relative;
      
      .el-icon-document {
        font-size: 24px;
        color: #909399;
        margin-right: 10px;
      }
      
      .file-info {
        flex: 1;
        .file-name {
          font-size: 14px;
          color: #606266;
        }
      }

      .remove-file {
        position: absolute;
        right: 10px;
        font-size: 16px;
        color: #909399;
        cursor: pointer;
        transition: color 0.2s;
        
        &:hover {
          color: #F56C6C;
        }
      }
    }
  }
  
  /deep/ .el-dialog__body {
    padding: 0 20px;
  }

  /deep/ .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #e8e8e8;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #e8e8e8;
  }
}

.signature-dialog {
  .info-section {
    margin-bottom: 20px;
    
    h3 {
      margin-bottom: 10px;
      color: #606266;
      font-size: 16px;
    }
  }
  
  .no-signature, .error-message {
    text-align: center;
    padding: 20px;
    color: #909399;
    
    i {
      font-size: 24px;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
  
  .error-message {
    color: #F56C6C;
  }
  
  /deep/ .el-descriptions {
    margin-bottom: 15px;
    
    .el-descriptions-item__label {
      width: 150px;
      background-color: #fafafa;
    }
  }
}
</style>
